import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { TableComponent } from 'src/app/shared/common-components/table/table.component';
import { CodeEnforcementService } from '../../code-enforcement.service';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';



@Component({
  selector: 'app-case-listing',
  templateUrl: './case-listing.component.html',
  styleUrls: ['./case-listing.component.scss']
})
export class CaseListingComponent implements OnInit {

  public caseList: any;
  public showSpinner: boolean = false;
  public tableColumnsNames;
  public categories: any;
  public days: any;
  public status: any;
  private caseId: any;
  public closeStatus: any;
  public openStatus: any;
  public resolvedCategory: any;
  public resolve: boolean = false;
  public valid: any;
  @ViewChild(TableComponent, { static: false }) tableComp: TableComponent;
  @ViewChild(MatTable, { static: false }) table: MatTable<any>;
  //@ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false })
  set paginator(value: MatPaginator) {
    if (this.dataSource) {
      this.dataSource.paginator = value;
    }
  }
  //@ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort, { static: false })
  set sort(value: MatSort) {
    if (this.dataSource) {
      this.dataSource.sort = value;
    }
  }
  @ViewChild('formRef') formRef: TemplateRef<any>;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  @ViewChild('searchFormRef') searchFormRef: TemplateRef<any>;

  public columnNames = ['Case', 'Date', 'Violation', 'User', 'StreetNo',
    'Street', 'DaystoCure', 'Category', 'Status', 'ExpiryDate', 'IsExpired', "actions"
  ];
  @Input() tableData;
  dataSource = new MatTableDataSource();
  updateCaseListForm: FormGroup;
  searchForm: FormGroup;
  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  private selectedItem;
  public caseIds;

  constructor(
    private formBuilder: FormBuilder,
    private codeEnforcementService: CodeEnforcementService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,

  ) {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    }
  }

  ngOnInit(): void {

    this.updateCaseListForm = this.formBuilder.group({
      statusId: ['', Validators.required],
      daysToCureId: ['', Validators.required],
      categoryId: ['', Validators.required],
    });

    this.searchForm = this.formBuilder.group({
      case: [''],
      statusId: [''],
      daysToCureId: [''],
      categoryId: [''],
      isExpired: ['']
    });
    this.fetchAllCases();

    this.codeEnforcementService.fetchAllCategories().subscribe((categoryRes) => {
      this.categories = categoryRes.categoryList.filter(f => f.category != 'Other');;
      console.log(this.categories, 'categg')
      this.categories.sort((a, b) => a.category.localeCompare(b.category));
      this.resolvedCategory = this.categories.filter(s => s.category == 'Resolved')
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });

    this.codeEnforcementService.fetchAllDaysToCure().subscribe((daysRes) => {
      let cusArr = [];
      this.days = daysRes.DaysToCureList.filter(f => f.numberOfDays != 'Other');;
      cusArr = this.days.sort((a, b) => {
        return a.numberOfDays - b.numberOfDays;
      });
      this.days = cusArr;
      // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });

    this.codeEnforcementService.fetchStatus().subscribe((statusRes) => {
      this.status = statusRes.statusList;
      // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
      this.closeStatus = this.status.filter(s => s.status == 'Closed')
      this.openStatus = this.status.filter(s => s.status == 'Open')
    });

    // this.filteredOptions = this.searchForm.controls['case'].valueChanges.pipe(
    //   startWith(''),
    //   map(value => this._filter(value))
    // );

    // this.updateCaseListForm.controls['statusId'].valueChanges.subscribe(
    //   (value) => {
    //     this.codeEnforcementService.fetchStatus().subscribe((statusRes) => {
    //       this.status = statusRes.statusList;
    //       // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
    //       // this.streets.sort((a, b) => a.street.localeCompare(b.street));
    //     });
    //     const closeStatus = this.status.filter(s => s.status == 'Close')
    //     if (value == closeStatus[0].id) {
    //       this.resolve = true;
    //     } else {
    //       this.resolve = false;
    //     }
    //   }
    // );


    // this.updateCaseListForm.controls['categoryId'].valueChanges.subscribe(
    //   (value) => {
    //     this.codeEnforcementService.fetchAllCategories().subscribe((categoryRes) => {
    //       this.categories = categoryRes.categoryList;
    //       console.log(this.categories, 'categg')
    //       // this.streets.sort((a, b) => a.street.localeCompare(b.street));
    //     });
    //     const resolvedCategory =   this.categories.filter(s => s.category == 'Resolved')
    //    if(value == resolvedCategory[0].id && this.updateCaseListForm.value.statusId == ){

    //     this.resolve = false;
    //    }else{
    //     this.resolve = true;
    //    }
    //   }
    // );
  }
  // validateStatus(control: AbstractControl){
  //   this.codeEnforcementService.fetchStatus().subscribe((statusRes) => {
  //     this.status = statusRes.statusList;
  //     // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
  //     // this.streets.sort((a, b) => a.street.localeCompare(b.street));
  //   });
  //   const closeStatus = this.status.filter(s => s.status == 'Close')
  //       return control.value == closeStatus[0].id? { statusClose: true } : null;
  // }
  renderTable() {
    console.log('reder rows');
    this.dataSource.data = this.tableData.filter(elem => elem);

    console.log(this.tableData, 'table data')
    this.table.renderRows();
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.caseIds.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  // }

  // editCaseList(e){
  //   console.log('imm in edit.....');
  // }

  // startEdit() {

  // }
  deleteItem(data) {
    localStorage.setItem('deleteCaseData', JSON.stringify(data).toString());
    this.confirmDialog = this.dialog.open(this.confirmRef, {
      width: '350px',
      data: 'data'
    });
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  confirmDelete() {
    const data = JSON.parse(localStorage.getItem('deleteCaseData'));
    this.codeEnforcementService.deleteCaseById(data).subscribe((res) => {
      this._snackBar.open('Success :' + res.message, '', {
        duration: 5000,
        horizontalPosition: 'right',
        panelClass: 'success-snackbar'
      });
      console.log(res)
      this.fetchAllCases();
    });
    this.confirmDialog.close();
  }

  onNoClick() {
    this.confirmDialog.close();
  }


  openDialogUpdateForm(caseList) {
    if (caseList) {
      this.resolve = false;
    }
    localStorage.setItem('caseId', caseList.CaseId);
    this.formDialog = this.dialog.open(this.formRef, {
      width: '350px',
      data: 'data'
    });

    this.updateCaseListForm.patchValue({
      //  streetNumber: item.data.streetNumber,
      daysToCureId: caseList.daysToCureId,
      categoryId: caseList.categoryId,
      statusId: caseList.statusId
    });
    // this.formDialog.afterClosed().subscribe(result => {
    //   // this.selectedItem = '';
    //   // this.yearCycleForm.reset();
    //   // this.yearId = null;
    // })
  }

  fetchAllCases() {
    this.showSpinner = true;
    console.log(this.tableData, 'dataaa');
    if (this.tableData == undefined) {
      this.codeEnforcementService.fetchAllCases(this.searchForm.value).subscribe((res) => {
        console.log(res);
        this.showSpinner = false;
        if (res.casesList.length > 0) {
          let cases = [];
          res.casesList.map((data: any) => {
            let statusOpen;
            if (data && data.caseStatus && data.caseStatus.status && data.caseStatus.status == 'Open') {
              if (data.isExpired) {
                statusOpen = 'Expired';
              } else {
                statusOpen = 'NotExpired';
              }
            }
            let caseData = {
              'Case': data.case,
              'CaseId': data.id,
              'Date': data.date,
              'Violation': (data && data.violation) ? data.violation.violation : null,
              'User': (data && data.user) ? data.user.userName : null,
              'DaystoCure': (data && data.daysToCure) ? data.daysToCure.numberOfDays : null,
              'daysToCureId': (data && data.daysToCure) ? data.daysToCure.id : null,
              'Category': (data && data.category) ? data.category.category : null,
              'categoryId': (data && data.category) ? data.category.id : null,
              'Status': (data && data.caseStatus) ? data.caseStatus.status : null,
              'statusId': (data && data.caseStatus) ? data.caseStatus.id : null,
              'StreetNo': data.streetNo,
              'Street': (data && data.streets) ? data.streets.street : null,
              'ExpiryDate': data.expiryDate,
              'IsExpired': statusOpen ? statusOpen : '--'
            }
            cases.push(caseData);
          })
          this.caseList = cases;
          if (this.searchForm.touched) {
            this.confirmDialog.close();
          }

          this.caseIds = this.caseList.map(c => c.Case);
          console.log(this.caseIds, 'idddd')
          if (this.caseList) {
            this.caseList.sort((a, b) => <any>new Date(b.Date).getTime() - <any>new Date(a.Date).getTime())
            this.dataSource.data = this.caseList;
          }
          console.log(this.caseList, 'list')
          // this.tableRendering();
        } else {
          this.dataSource.data = [];
        }
      });
    }
    if (this.tableData) {
      this.showSpinner = false;
      this.caseList = this.tableData;
      // this.tableRendering();
      console.log(this.tableData, 'tab')
      this.dataSource.data = this.tableData;
      // this.dataSource.paginator = this.paginator;
      // this.dataSource.sort = this.sort;
    }
    // if (this.confirmDialog) this.confirmDialog.close();
  }


  onSubmit() {
    console.log('update....');
    // e.preventDefault();
    // this.yearCycleForm.controls['year'].disable()
    this.showSpinner = true;
    this.caseId = localStorage.getItem('caseId');
    this.updateCaseListForm.value['caseId'] = this.caseId;
    this.codeEnforcementService.updateCaseList(this.updateCaseListForm.value).subscribe((res) => {
      this.showSpinner = false;
      this.formDialog.close();
      this.updateCaseListForm.reset();
      this.selectedItem = '';
      if (res.message == 'Case already exists with same details') {
        this._snackBar.open('Warning :' + res.message, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
      } else {
        this._snackBar.open('Success :' + res.message, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
        this.fetchAllCases();
      }
      console.log(this.selectedItem, 'editt')

    }, error => {
      let errorMessage: string;
      if (error.error.message) {
        errorMessage = error.error.message;
      } else {
        errorMessage = `${error.message}`;
      }
      console.log(error);
      this._snackBar.open('Warning :' + errorMessage, '', {
        duration: 3000,
        horizontalPosition: 'right',
        panelClass: 'warning-snackbar'
      });
      this.showSpinner = false;
    });
  }

  // onSubmitSearch() {
  //   this.showSpinner = true;
  //   console.log(this.tableData, 'dataaa');
  //   if (this.tableData == undefined) {
  //     this.codeEnforcementService.fetchAllCases(this.searchForm.value).subscribe((res) => {
  //       console.log(res);
  //       this.showSpinner = false;
  //       if (res.casesList.length > 0) {
  //         let cases = [];
  //         res.casesList.map((data: any) => {
  //           let statusOpen;
  //           if (data && data.caseStatus && data.caseStatus.status && data.caseStatus.status == 'Open') {
  //             if (data.isExpired) {
  //               statusOpen = 'Expired';
  //             } else {
  //               statusOpen = 'NotExpired';
  //             }
  //           }
  //           let caseData = {
  //             'Case': data.case,
  //             'CaseId': data.id,
  //             'Date': data.date,
  //             'ExpiryDate': data.expiryDate,
  //             'Violation': (data && data.violation) ? data.violation.violation : null,
  //             'User': (data && data.user) ? data.user.userName : null,
  //             'DaystoCure': (data && data.daysToCure) ? data.daysToCure.numberOfDays : null,
  //             'daysToCureId': (data && data.daysToCure) ? data.daysToCure.id : null,
  //             'Category': (data && data.category) ? data.category.category : null,
  //             'categoryId': (data && data.category) ? data.category.id : null,
  //             'Status': (data && data.caseStatus) ? data.caseStatus.status : null,
  //             'statusId': (data && data.caseStatus) ? data.caseStatus.id : null,
  //             'StreetNo': data.streetNo,
  //             'Street': (data && data.streets) ? data.streets.street : null,
  //             'IsExpired': statusOpen ? statusOpen : '--'
  //           }
  //           cases.push(caseData);
  //         })
  //         this.caseList = cases;
  //         if (this.caseList) {
  //           this.dataSource.data = this.caseList;
  //         }
  //         console.log(this.caseList, 'list')
  //         // this.tableRendering();
  //       } else {
  //         this.dataSource.data = [];
  //       }
  //     });
  //   }
  //   if (this.tableData) {
  //     this.showSpinner = false;
  //     this.caseList = this.tableData;
  //     // this.tableRendering();
  //     console.log(this.tableData, 'tab')
  //     this.dataSource.data = this.tableData;
  //   }
  //   this.confirmDialog.close();
  // }

  reset() {
    this.searchForm.reset();
    this.fetchAllCases();
  }

  openDialogForSearch() {
    // this.searchForm.reset();
    this.confirmDialog = this.dialog.open(this.searchFormRef, {
      width: '550px',
      data: 'data'
    });
  }

  clear() {
    console.log('usha...............');
    this.searchForm.reset();
  }

}
